export default __webpack_public_path__ + "static/B0315-5350be4f3b14a0535ba0f5c48992e1c9.png";